import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, pluck, startWith } from 'rxjs/operators'

import * as OrgSelectors from 'modules/org/selectors'

import * as actions from './actions'
import { api } from './api'

const updateInbox = (action$, state$) => {
  return action$.pipe(
    ofType(actions.updateInbox.toString()),
    pluck('payload'),
    mergeMap((properties) => {
      const orgId = OrgSelectors.getInboxId(state$.value)

      return api.updateInbox(orgId, properties).pipe(
        map(actions.updateInboxSuccess),
        startWith(actions.updateInboxPending()),
        catchError(() => of(actions.updateInboxFailed()))
      )
    })
  )
}

export const epic = combineEpics(updateInbox)
